/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Timer from './Timer';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/timer-box.module.scss';

const propTypes = {
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    label: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
    started: PropTypes.bool,
    onEnded: PropTypes.func,
    maxPerDay: PropTypes.number,
    maxPerWeek: PropTypes.number,
    timerClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    date: null,
    label: null,
    started: false,
    onEnded: null,
    maxPerDay: null,
    maxPerWeek: null,
    timerClassName: null,
    className: null,
};

function TimerBox({
    date,
    label,
    started,
    onEnded,
    maxPerDay,
    maxPerWeek,
    timerClassName,
    className,
}) {
    const themeClassName = useThemeClassName(styles);

    const defaultLabel =
        maxPerDay !== null || maxPerWeek !== null ? (
            <FormattedMessage
                defaultMessage="You’ve played {count, plural, =0 {# times}  one  {# time} other {# times}} already. That's it for now. Come back in:"
                description="Timer description"
                values={{
                    count: maxPerDay || maxPerWeek,
                }}
            />
        ) : (
            <FormattedMessage
                defaultMessage="Come back to play in:"
                description="Timer description"
            />
        );

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.label}>{label !== null ? label : defaultLabel}</div>
            <Timer
                date={date}
                started={started}
                onEnded={onEnded}
                className={classNames([
                    styles.timer,
                    { [timerClassName]: timerClassName !== null },
                ])}
            />
        </div>
    );
}

TimerBox.propTypes = propTypes;
TimerBox.defaultProps = defaultProps;

export default TimerBox;
